import React, { useEffect, useCallback, useState} from 'react';
import KeyListener from '../KeyListener.js';

export const useKeyListener = (props) => { 
    let [keyListener, setKeyListener] = useState(
        undefined);

    useEffect(() => {
        if (props.sequencerEngine) {
            setKeyListener(new KeyListener(props.sequencerEngine));
        }
    }, [props.sequencerEngine]);

    useEffect(() => {
        if (!keyListener) {
            return undefined;
        }
        window.addEventListener('keydown', keyListener.onKeyDown);
        window.addEventListener('keyup', keyListener.onKeyUp);
        return () => {
            window.removeEventListener('keydown', keyListener.onKeyDown);
            window.removeEventListener('keyup', keyListener.onKeyUp);
        };
    }, [keyListener]);

    return [keyListener];
}

